module.exports = __webpack_public_path__ + "60bad7134fe68f23b87b7336f80e64c7.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/shadow_20x60.png
// module id = 528
// module chunks = 0